function customOpenPopup(handle, button) {

  if (button) {
    button.classList.add('is-loading');
    button.disabled = true;
  }

  customCloseCart();
  const popupBody = document.getElementById("productHtml");
  if (popupBody) {
    popupBody.innerHTML = "<p>Loading...</p>";
  }

  fetch(`/products/${handle}?view=quick-view`)
    .then(res => res.text())
    .then(html => {
      const parser = new DOMParser();
      const doc = parser.parseFromString(html, "text/html");
      const productInfo = doc.querySelector("product-info");
      
      if (!productInfo) {
        console.error("No <product-info> found in quick view template");
        return;
      }

      popupBody.innerHTML = "";
      popupBody.appendChild(productInfo);

      // Remove problematic modal scripts before execution
      const scripts = productInfo.querySelectorAll('script');
      scripts.forEach(oldScript => {
        // Skip scripts that might cause conflicts
        if (oldScript.src.includes('product-modal') || 
            oldScript.textContent.includes('ModalDialog') ||
            oldScript.textContent.includes('product-modal')) {
          console.log('Skipping modal script to prevent conflicts');
          return;
        }

        const newScript = document.createElement('script');
        
        // Copy all attributes
        Array.from(oldScript.attributes).forEach(attr => {
          newScript.setAttribute(attr.name, attr.value);
        });
        
        // Copy content for inline scripts
        if (oldScript.src) {
          newScript.src = oldScript.src;
        } else {
          // Wrap inline scripts in try-catch to prevent errors from breaking execution
          newScript.textContent = `
            try {
              ${oldScript.textContent}
            } catch (error) {
              console.log('Script execution error in quick view:', error);
            }
          `;
        }
        
        document.head.appendChild(newScript);
        document.body.classList.add('page-scroll-disabled');
      });

      // Fix close button functionality
      fixCloseButtons();
      
      // Show popup
      document.getElementById("custom-popup")?.classList.add("custom-active");
      document.getElementById("custom-overlay")?.classList.add("custom-active");
    })
    .catch(err => console.error("Quick View load failed:", err))    
    .finally(() => {
      if (button) {
        button.classList.remove('is-loading');
        button.disabled = false;
      }
    });
}

// Fix close buttons in the loaded content
function fixCloseButtons() {
  const popupBody = document.getElementById("productHtml");
  
  // Remove existing onclick handlers and use event delegation
  const closeButtons = popupBody.querySelectorAll('[onclick*="close"], [onclick*="customClosePopup"]');
  closeButtons.forEach(button => {
    button.removeAttribute('onclick');
  });
  
  // Add fresh event listeners
  setTimeout(() => {
    const newCloseButtons = popupBody.querySelectorAll('.close-popup, [data-close-popup]');
    newCloseButtons.forEach(button => {
      button.addEventListener('click', customClosePopup);
    });
  }, 100);
}

// Make sure customClosePopup is globally available
window.customClosePopup = function() {
  document.getElementById("custom-popup")?.classList.remove("custom-active");
  document.getElementById("custom-overlay")?.classList.remove("custom-active");
  document.body.classList.remove('page-scroll-disabled');
};

// Enhanced overlay close with event delegation
document.addEventListener("DOMContentLoaded", function () {
  const overlayEl = document.getElementById("custom-overlay");
  if (overlayEl) {
    overlayEl.addEventListener("click", customClosePopup);
  }
  
  // Event delegation for dynamically loaded close buttons
  document.addEventListener('click', function(e) {
    if (e.target.closest('[data-close-quickview]') || 
        e.target.closest('.quickview-close') ||
        e.target.classList.contains('close-popup')) {
      customClosePopup();
    }
  });
});

// video testimonials model
// function videoProductModel(handle) {
//   // Close cart if open
//   customCloseCart();

//   const popupBody = document.getElementById("productHtml");
//   if (popupBody) {
//     popupBody.innerHTML = "<p>Loading video testimonial...</p>";
//   }

//   // Fetch the product template with ?view=video-testimonials
//   fetch(`/products/${handle}?view=video-testimonials`)
//     .then(res => res.text())
//     .then(html => {
//       const parser = new DOMParser();
//       const doc = parser.parseFromString(html, "text/html");

//       // You can change this selector based on your template structure
//       // If your video section is inside a <video-section> or <product-video> tag, update it here.
//       const productVideoSection =
//         doc.querySelector("product-info") ||
//         doc.querySelector(".video-testimonials") ||
//         doc.querySelector("[data-video-testimonials]");

//       if (!productVideoSection) {
//         console.error("No video testimonials section found in template");
//         popupBody.innerHTML = "<p>Video testimonials not available.</p>";
//         return;
//       }

//       // Clear and append
//       popupBody.innerHTML = "";
//       popupBody.appendChild(productVideoSection);
    
//       // Process scripts safely
//       const scripts = productVideoSection.querySelectorAll("script");
//       scripts.forEach(oldScript => {
//         if (
//           oldScript.src.includes("product-modal") ||
//           oldScript.textContent.includes("ModalDialog") ||
//           oldScript.textContent.includes("product-modal")
//         ) {
//           console.log("Skipping conflicting modal script");
//           return;
//         }

//         const newScript = document.createElement("script");
//         Array.from(oldScript.attributes).forEach(attr => {
//           newScript.setAttribute(attr.name, attr.value);
//         });

//         if (oldScript.src) {
//           newScript.src = oldScript.src;
//         } else {
//           newScript.textContent = `
//             try {
//               ${oldScript.textContent}
//             } catch (error) {
//               console.log('Error in video testimonials script:', error);
//             }
//           `;
//         }

//         document.head.appendChild(newScript);
//       });

//       // Re-init close functionality
//       fixCloseButtons();

//       // Show popup
//       document.getElementById("custom-popup")?.classList.add("custom-active");
//       document.getElementById("custom-overlay")?.classList.add("custom-active");
//     })
//     .catch(err => {
//       console.error("Video testimonials load failed:", err);
//       if (popupBody) {
//         popupBody.innerHTML =
//           "<p>Something went wrong while loading video testimonials.</p>";
//       }
//     });
// }

function videoProductModel(handle) {
  // Close cart if open
  customCloseCart();

  const popupBody = document.getElementById("productHtml");
  if (popupBody) {
    popupBody.innerHTML = "<p>Loading video testimonial...</p>";
  }

  // Fetch the product template with ?view=video-testimonials
  fetch(`/products/${handle}?view=video-testimonials`)
    .then(res => res.text())
    .then(html => {
      const parser = new DOMParser();
      const doc = parser.parseFromString(html, "text/html");

      // You can change this selector based on your template structure
      // If your video section is inside a <video-section> or <product-video> tag, update it here.
      const productVideoSection =
        doc.querySelector("product-info") ||
        doc.querySelector(".video-testimonials") ||
        doc.querySelector("[data-video-testimonials]");

      if (!productVideoSection) {
        console.error("No video testimonials section found in template");
        popupBody.innerHTML = "<p>Video testimonials not available.</p>";
        return;
      }

      // Clear and append
      popupBody.innerHTML = "";
      popupBody.appendChild(productVideoSection);
      document.body.classList.add('page-scroll-disabled');
      // Process scripts safely
      const scripts = productVideoSection.querySelectorAll("script");
      scripts.forEach(oldScript => {
        if (
          oldScript.src.includes("product-modal") ||
          oldScript.textContent.includes("ModalDialog") ||
          oldScript.textContent.includes("product-modal")
        ) {
          console.log("Skipping conflicting modal script");
          return;
        }

        const newScript = document.createElement("script");
        Array.from(oldScript.attributes).forEach(attr => {
          newScript.setAttribute(attr.name, attr.value);
        });

        if (oldScript.src) {
          newScript.src = oldScript.src;
        } else {
          newScript.textContent = `
            try {
              ${oldScript.textContent}
            } catch (error) {
              console.log('Error in video testimonials script:', error);
            }
          `;
        }

        document.head.appendChild(newScript);
      });

      // Re-init close functionality
      fixCloseButtons();
      // ✅ INITIALIZE CAROUSEL AFTER HTML IS UPDATED
      const carouselContainer = popupBody.querySelector('[data-product-media-carousel]');
      if (carouselContainer) {
        // Destroy existing carousel if any
        if (window.popupProductCarousel) {
          window.destroyPopupCarousel(window.popupProductCarousel);
        }
        
        // Initialize new carousel
        window.popupProductCarousel = window.initProductMediaCarousel(carouselContainer);
        console.log('Popup carousel initialized');
      } else {
        console.log('No carousel container found in popup');
      }

      // Show popup
      document.getElementById("custom-popup")?.classList.add("custom-active");
      document.getElementById("custom-overlay")?.classList.add("custom-active");
    })
    .catch(err => {
      console.error("Video testimonials load failed:", err);
      if (popupBody) {
        popupBody.innerHTML =
          "<p>Something went wrong while loading video testimonials.</p>";
      }
    });
}

// Also update your destroy function to handle popup carousel
window.destroyPopupCarousel = function(carousel) {
  if (carousel && typeof carousel.destroy === 'function') {
    carousel.destroy();
  }
};


/* ============= Megamenu hover js ============ */

document.addEventListener('DOMContentLoaded', function () {
  if (window.innerWidth < 990) return; // Desktop only

  const megaMenus = document.querySelectorAll('.header--has-menu details');

  megaMenus.forEach(details => {
    const content =
      details.querySelector('.mega-menu__content') ||
      details.querySelector('.header__submenu');

    if (!content) return;

    // INITIAL SETUP
    content.style.minHeight = '0px';
    content.style.opacity = '0';
    content.style.overflow = 'hidden';
    content.style.transition = 'min-height 0.35s ease, opacity 0.35s ease';

    // --- HOVER IN ---
    details.addEventListener('mouseenter', () => {
      details.setAttribute('open', true);

      // Natural submenu height
      const naturalHeight = content.scrollHeight;

      // ⭐ Use min-height instead of height
      content.style.minHeight = naturalHeight + 'px';
      content.style.opacity = '1';
    });

    // --- HOVER OUT ---
    details.addEventListener('mouseleave', () => {
      content.style.minHeight = '0px';
      content.style.opacity = '0';

      setTimeout(() => {
        details.removeAttribute('open');
      }, 350);
    });

    // --- WINDOW RESIZE FIX ---
    window.addEventListener('resize', () => {
      if (details.hasAttribute('open')) {
        const naturalHeight = content.scrollHeight;
        content.style.minHeight = naturalHeight + 'px';
      }
    });
  });
});


/* ============= Megamenu hover js ============ */


// collection page filter button 
(function () {
  const btn = document.getElementById('filterBtn');
  const mainFilters = document.getElementById('main-collection-filters');

  if (!btn || !mainFilters) return;

  btn.addEventListener('click', () => {
    const isOpen = btn.getAttribute('aria-expanded') === 'true';
    const nowOpen = !isOpen;

    // Update aria attribute
    btn.setAttribute('aria-expanded', String(nowOpen));

    // Toggle visibility
    if (nowOpen) {
      mainFilters.style.display = 'none';
    } else {
      mainFilters.style.display = 'block';
    }
  });
})();


